import React from 'react';

const DeleteUserModal = ({
  isOpen,
  onClose,
  loading,
  errors,
  targetUser,
  masterKey,
  onMasterKeyChange,
  onSubmit,
}) => {
  if (!isOpen || !targetUser) return null;

  const displayName = `${targetUser.first_name || ''} ${targetUser.last_name || ''}`.trim()
    || targetUser.email;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        zIndex: 1002,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px'
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div style={{
        width: '100%',
        maxWidth: '520px',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
        overflow: 'hidden'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 18px',
          borderBottom: '1px solid #e5e7eb'
        }}>
          <div style={{
            fontFamily: '"Baikal Book"',
            fontSize: '16px',
            fontWeight: 900,
            color: '#991b1b'
          }}>
            Delete User
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '20px',
              lineHeight: 1,
              padding: '6px 8px',
              borderRadius: '8px',
              color: '#111827',
              opacity: loading ? 0.6 : 1
            }}
          >
            ×
          </button>
        </div>

        <form onSubmit={onSubmit} style={{ padding: '18px' }}>
          <p style={{
            margin: '0 0 12px',
            fontFamily: '"Baikal Book"',
            fontSize: '14px',
            color: '#374151',
            lineHeight: 1.5
          }}>
            This permanently deletes <strong>{displayName}</strong> ({targetUser.email}) and all related data.
            This action cannot be undone.
          </p>

          <p style={{
            margin: '0 0 16px',
            fontFamily: '"Baikal Book"',
            fontSize: '13px',
            color: '#6b7280',
            lineHeight: 1.5
          }}>
            For the master key, contact the dev team.
          </p>

          <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
            Master key
          </label>
          <input
            type="password"
            value={masterKey}
            onChange={onMasterKeyChange}
            disabled={loading}
            autoComplete="off"
            style={{
              width: '100%',
              padding: '10px 12px',
              border: errors.master_key ? '1px solid #ef4444' : '1px solid #d1d5db',
              borderRadius: '8px',
              fontFamily: '"Baikal Book"',
              fontSize: '14px',
              boxSizing: 'border-box'
            }}
          />
          {errors.master_key && (
            <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '6px', fontFamily: '"Baikal Book"' }}>
              {Array.isArray(errors.master_key) ? errors.master_key[0] : errors.master_key}
            </div>
          )}
          {errors.detail && (
            <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '10px', fontFamily: '"Baikal Book"' }}>
              {errors.detail}
            </div>
          )}
          {errors.error && (
            <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '10px', fontFamily: '"Baikal Book"' }}>
              {errors.error}
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '10px 16px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                background: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: '"Baikal Book"',
                fontSize: '14px'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !masterKey.trim()}
              style={{
                padding: '10px 16px',
                border: 'none',
                borderRadius: '8px',
                background: loading || !masterKey.trim() ? '#fca5a5' : '#dc2626',
                color: 'white',
                cursor: loading || !masterKey.trim() ? 'not-allowed' : 'pointer',
                fontFamily: '"Baikal Book"',
                fontSize: '14px',
                fontWeight: 700
              }}
            >
              {loading ? 'Deleting...' : 'Delete User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteUserModal;
